import api from "@/apis/TransactionControlAPI";
import Crud from "./crud-base";
var crud = new Crud("transactioncontrol", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "transactioncode",
      code: "billcode",
      name: "branchname",
    },
  },
  datas: [],
  // Tổng số tiền hiển thị
  generaltrans: {
    totalOrderAmount: 0,
    totalDiscount: 0,
    totalFeeAmount: 0,
    totalAmount: 0,
  },
};
const getters = {
  ...crud.getters,
  generaltrans: function (state) {
    return state.generaltrans;
  },
};
const actions = {
  ...crud.actions,
  /**
   * Load danh sách giao dịch đối soát
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }

    if (res && !payload.notUpdateItem) {
      context.commit("setItems", { result: res, payload: payload });
    } else {
      context.commit("setDatas", { result: res, payload: payload });
    }
    // if(res && res.items && res.items.length > 0){
    //     let generaltrans = {};
    //     generaltrans.totalOrderAmount = res.items[0].customData.totalOrderAmount;
    //     generaltrans.totalDiscount = 0;
    //     generaltrans.totalFeeAmount = res.items[0].customData.totalFeeAmount;
    //     generaltrans.totalAmount = res.items[0].customData.totalPaymentAmount;
    //     res.generaltrans = generaltrans;
    //     context.commit("updateGeneraltrans", res);
    //     return res;
    // }
    return res;
  },
  // generaltrans: async function(context, payload){
  //     let res = res = await api.getList(payload || {});
  //     if(res && res.items && res.items.length > 0){
  //         let generaltrans = {};
  //         generaltrans.totalOrderAmount = res.items[0].customData.totalOrderAmount;
  //         generaltrans.totalDiscount = 0;
  //         generaltrans.totalFeeAmount = res.items[0].customData.totalFeeAmount;
  //         generaltrans.totalAmount = res.items[0].customData.totalPaymentAmount;
  //         res.generaltrans = generaltrans;
  //         context.commit("updateGeneraltrans", res);
  //         return res;
  //     }
  // },
  async export(context, payload) {
    await api.export(payload || {});
  },
};
const mutations = {
  ...crud.mutations,
  setDatas(state, data) {
    if (data.result) {
      if (data.result.length > 0) {
        state.datas.removeAll();
        state.datas = data.result;
        //state.dataTotal = resultValue;
      }

      //   case "Total":
      //     state.dataTotal = resultValue;
      //     break;
      //   case "Empty":
      //     state.dataEmpty = resultValue;
      //     break;
      //   case "Summary":
      //     state.dataSummary = resultValue;
      //     break;
      // }
    }

    // state.items.removeAll();
    // state.items.append(res.PageData);
    // if (!res.payload || !res.payload.skip) {
    //   state.total = res.Total;
    //   state.empty = res.Empty;
    // }
  },
  updateGeneraltrans(state, res) {
    if (res.items) {
      state.generaltrans = res.generaltrans;
    }
    // state.totalOrderAmount.append(res);
  },
};
export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
